'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hilightKeyword = hilightKeyword;
function hilightKeyword(keyword, text) {
  var indexes = [];
  text.split('').map(function (textChar) {
    var found = false;
    keyword.split('').map(function (keywordChar, index) {
      if (found) {
        return true;
      }
      if (textChar.toLowerCase() === keywordChar.toLowerCase() && indexes.indexOf(index) < 0) {
        indexes.push(index);
        found = true;
      }
    });
  });
  return indexes;
}


//////////////////
// WEBPACK FOOTER
// ./src/utils/suggestion.js
// module id = 482
// module chunks = 1 35